import { Component, OnInit, ViewEncapsulation } from '@angular/core';
import { SharedService } from '../../../shared/shared.service';
import { FormService } from '../../../shared/form.service';
import { TrackService } from 'src/app/services/track.service';

@Component({
  selector: 'app-details5',
  templateUrl: './details5.component.html',
  styleUrls: ['./details5.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class Details5Component implements OnInit {
  parentForm;
  salutations = ['Mr.', 'Mrs.']
  toText(value): string {
    return value ? value.toUpperCase() : null;
  }
  constructor(
    private formService: FormService,
    public sharedService: SharedService,
    public trackService: TrackService) {
  }

  ngOnInit(): void {
    this.parentForm = this.formService.currentForm;
  }


}
